function getEquationFromColumn(column) {
	return '[' + column + ']'
}

function getColumnFromEquation(equation) {
	return equation.replace('[', '').replace(']', '')
}

class FieldEquationFormatter {

	/**
	 * Formats field equations
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} [options.dataset] the starting dataset used to determine
	 * when the dataset name isn't required as part of the field reference. If
	 * not specified, all field references will be qualified with the dataset
	 * name
	 */
	constructor(options = {}) {
		this.dataset = options.dataset
	}

	/**
	 * Formats a column reference using data like this
	 *
	 * <pre>
	 * {
	 *  datasetId : 123,
	 *  column : 'Part Number'
	 * }
	 * </pre>
	 *
	 * So it's in a format like this:
	 *
	 * <pre>
	 * [Part Number]
	 * </pre>
	 *
	 * Or an equation like this:
	 *
	 * <pre>
	 * {
	 *  datasetId : 123,
	 *  dataset : 'Linked Dataset',
	 *  field : 'Linked Field'
	 * }
	 * </pre>
	 *
	 * So it's in a format like this:
	 *
	 * <pre>
	 * [Linked Dataset].[Linked Field]
	 * </pre>
	 *
	 * @param {Object} data
	 * @param {Number} [data.datasetId] the ID of the dataset this equation will
	 * belong to
	 * @param {String} [data.dataset] the dataset.  Must be specified for linked datasets
	 * @param {String} [data.columnOrField] the column or field.  Must be specified for non-linked datasets
	 * @param {String} [data.field] the field.  Must be specified for linked datasets
	 */
	format (data) {
		var result = '[' + (data.columnOrField || data.field) + ']'
		let rootDatasetId = this.dataset && this.dataset.get('rootDatasetId')
		// if the datasetId was specified, and it's not equal to the current dataset
		if (data.datasetId && data.datasetId !== rootDatasetId) {
			result = '[' + data.dataset + '].' + result
		}
		return result
	}
}

export default FieldEquationFormatter
export { getColumnFromEquation }
export { getEquationFromColumn }
FieldEquationFormatter.__filename__ = 'datasets/edit/field-equation-formatter.js'
